/**
 * @catalyst-psa/shared
 *
 * Cross-cutting contracts shared by backend, frontend, and jobs.
 * Keep this package free of runtime framework dependencies.
 */
export const API_VERSION = 'v1';
export const API_BASE_PATH = '/api/v1';
export * from './rbac.js';
export * from './errors.js';
export * from './pagination.js';
export * from './principal.js';
export * from './billing.js';
export * from './rate.js';
export * from './period.js';
export * from './report-format.js';
export * from './auth.js';
// Master-data & admin contracts.
export * from './contracts/customer.js';
export * from './contracts/customer-type.js';
export * from './contracts/contact.js';
export * from './contracts/product.js';
export * from './contracts/member.js';
export * from './contracts/role.js';
export * from './contracts/menu.js';
export * from './contracts/api-user.js';
export * from './contracts/data-feed.js';
export * from './contracts/audit.js';
// Time-core contracts (Phase 2).
export * from './contracts/service-category.js';
export * from './contracts/billing-class.js';
export * from './contracts/project.js';
export * from './contracts/project-phase.js';
export * from './contracts/project-portal.js';
export * from './contracts/bonus-report.js';
export * from './contracts/ticket.js';
export * from './contracts/ticket-diagnostics.js';
export * from './contracts/ticket-portal.js';
export * from './contracts/ticket-status.js';
export * from './contracts/ticket-type-group.js';
export * from './contracts/ticket-type.js';
export * from './contracts/project-rate.js';
export * from './contracts/project-product.js';
export * from './contracts/time-entry.js';
export * from './contracts/timesheet.js';
// Agreement & ledger contracts (Phase 3).
export * from './contracts/agreement.js';
export * from './contracts/agreement-subtype.js';
export * from './contracts/agreement-service-category-rate.js';
export * from './contracts/agreement-period.js';
// Sales / CRM contracts.
export * from './contracts/opportunity.js';
export * from './contracts/forecast.js';
export * from './contracts/onboarding.js';
export * from './contracts/onboarding-portal.js';
export * from './contracts/quote.js';
// Invoice contracts (Phase 4).
export * from './contracts/invoice.js';
export * from './contracts/invoice-template.js';
// Billing Audit contracts (admin-only billing-control data).
export * from './contracts/billing-audit.js';
// QBO integration contracts (Phase 5).
export * from './contracts/qbo.js';
// Reporting contracts (RBAC area: reports).
export * from './contracts/report.js';
// Dashboard canvas + card contracts (menu item: dashboards; cards are viewer-scoped).
export * from './contracts/dashboard.js';
export * from './contracts/dashboard-fields.js';
// Customer-facing weekly report contracts (RBAC area: reports).
export * from './contracts/customer-report.js';
// Notification engine contracts (Insights; admin-managed).
export * from './contracts/notification.js';
// Outgoing mail settings (admin-only).
export * from './contracts/mail.js';
export * from './contracts/graph.js';
// ConnectWise CPQ (Sell API) connection settings (admin-only).
export * from './contracts/cpq.js';
// Catalyst Public API (api.nscatalyst.com) integration settings (admin-only).
export * from './contracts/catalyst-portal.js';
// "Ask PSA" AI assistant (Anthropic) — admin settings + member chat.
export * from './contracts/assistant.js';
// Insights Studio — AI-driven conversational analytics (menu item: insights-studio).
export * from './contracts/insights-studio.js';
// Maintenance mode (admin-only safety valve for deploys).
export * from './contracts/maintenance.js';
// Top-bar Recent + Favorites quick-access (per member).
export * from './contracts/quick-access.js';
// Per-member UI preferences (appearance theme + accent).
export * from './contracts/preferences.js';
// Sandbox mode (disposable training environment; integrations hard-disabled).
export * from './contracts/sandbox.js';
// PSA Snapshot Management (admin control of the disposable sandbox).
export * from './contracts/snapshot.js';
// ConnectWise read-only connector contracts (Phase 6).
export * from './contracts/connectwise.js';
// ClickUp integration contracts (webhooks; admin-managed).
export * from './contracts/clickup.js';
// MailerLite integration contracts (one-way contact push; admin-managed).
export * from './contracts/mailerlite.js';
//# sourceMappingURL=index.js.map